export default {
  SET_LIST_MAIL_FOLDER(state, listMailFolder) {
    state.listMailFolder = listMailFolder
  },
  SET_SELECTED_MAIL_FOLDER(state, selectedMailFolder) {
    state.selectedMailFolder = selectedMailFolder
  }
}